import React from 'react';

const ArrowIcon = ({ direction = 'left' }) => {
  return (
    <i
      className={`pi pi-arrow-right`}
      style={{
        position: 'relative',
        top: '1px',
        fontSize: '1.4rem',
        paddingLeft: '5px',
      }}
    />
  );
};

export default ArrowIcon;
